<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
					<a-tabs default-active-key="1">
            <a-tab-pane key="1" :tab="$t('promotion.freeCoinPerAmount')">
							<div class="ts-space-y-4">
								<div class="row">
									<div class="col-md-7">
										<form class="form-horizontal ts-space-y-3">
											<div class="row">
												<label
													class="col-md-3 col-form-label ts-text-xs required ts-font-light"
												>{{ $t('promotion.eventName') }}</label>
												<div class="col-md-8">
													<input v-model="model.promotion_name" type="text" class="form-control" />
													<div
														class="validate ts-text-xs"
														v-if="errors.has('promotion_name')"
													>{{ errors.first('promotion_name') }}</div>
												</div>
											</div>
											<div class="row">
												<label
													class="col-md-3 col-form-label ts-text-xs required ts-font-light"
												>{{ $t('promotion.startDate') }}</label>
												<div class="col-md-8">
													<a-date-picker
														v-model="model.promo_start_date"
														class="ts-w-full"
														format="DD-MM-YYYY"
														valueFormat="DD-MM-YYYY"
													></a-date-picker>
													<div
														class="validate ts-text-xs"
														v-if="errors.has('promo_start_date')"
													>{{ errors.first('promo_start_date') }}</div>
												</div>
											</div>
											<div class="row">
												<label class="col-md-3 col-form-label ts-text-xs"></label>
												<div class="col-md-8">
													<ts-checkbox
														v-model="model.is_no_end_date"
														class="ts-font-light"
														@change="() => model.promo_end_date = null"
													>{{ $t('promotion.tillFurtherNotice') }}</ts-checkbox>
												</div>
											</div>
											<div class="row">
												<label
													class="col-md-3 col-form-label ts-text-xs ts-font-light"
													:class="!model.is_no_end_date ? 'required' : null"
												>{{ $t('promotion.endDate') }}</label>
												<div class="col-md-8">
													<a-date-picker
														v-model="model.promo_end_date"
														:disabled="model.is_no_end_date"
														class="ts-w-full"
														format="DD-MM-YYYY"
														valueFormat="DD-MM-YYYY"
													></a-date-picker>
													<div
														class="validate ts-text-xs"
														v-if="errors.has('promo_end_date')"
													>{{ errors.first('promo_end_date') }}</div>
												</div>
											</div>
										</form>
									</div>
									<div class="col-md-5">
										<div class="ts-w-10/12 ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3">
											<BranchList v-model="model" />
											<div
												class="validate ts-text-xs"
												v-if="errors.has('branch_id_list')"
											>{{ errors.first('branch_id_list') }}</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<FreeCoinCodition
											v-model="model"
											:validate="errors"
											class="ts-border ts-border-gray-300 ts-rounded-md"
										/>
										<div
											class="validate ts-text-xs"
											v-if="errors.has('condition')"
										>{{ errors.first('condition') }}</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
										<ts-button @click.prevent="$router.push({ name: 'promotion'})">{{ $t('cancel') }}</ts-button>
										<ts-button
											:waiting="waiting"
											@click.prevent="onUpdate"
											color="primary"
										>{{ $t('update') }}</ts-button>
									</div>
								</div>
							</div>
						</a-tab-pane>
					</a-tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import BranchList from './components/branch-list'
import FreeCoinCodition from './components/free-coin-condition'

export default {
  name: 'freeCoinPerAmount',
  components: {
    BranchList,
    FreeCoinCodition
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        promotion_name: '',
        promo_type_id: 3,
        is_no_end_date: false,
        promo_start_date: '',
        promo_end_date: '',
        branch_id_list: [],
        condition: []
      }
    }
	},
  methods: {
    ...mapActions('promotion/freeCoinPerAmount', ['update', 'find']),
    ...mapActions('promotion/resource', ['getBranch', 'getSaleCode']),
    async fetchData() {
      this.loading = true
      await this.getBranch()
      await this.getSaleCode()
      await this.setEditData()
      this.loading = false
    },
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.model.promotion_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'promotion' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async setEditData() {
      await this.find(this.$route.params.id)
        .then(response => {
          let data = response.data
          this.setState(data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    setState(data) {
      this.model.promotion_id = data.promotion_id
      this.model.promotion_name = data.promotion_name
      this.model.prom_type_id = 3
      this.model.is_no_end_date = data.is_no_end_date
      this.model.promo_start_date = data.promo_start_date
      this.model.promo_end_date = data.promo_end_date
      this.model.branch_id_list = data.branches.map(el => el.branch_id)
      this.model.condition = data.conditions.map(el => ({
        operator_sign: el.operator_sign,
        amount_from: el.amount_from,
        amount_to: el.amount_to,
        coin_earned: el.coin_earned
      }))
    }
  },
	beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/resource/CLEAR_SETUP')
    next()
  }
}
</script>